export default "__VITE_ASSET__Caxj3$yZ__"